import SearchComponent from '@/components/search/component'
import { linkBuilders } from '@/helpers/mixins'

export default {
    extends: SearchComponent,
    mixins: [linkBuilders],
    computed: {
        level() {
            return this.catalogData.category.facetLevel
        },
        // Taken from the refinementCategory component
        categoryGroup() {
            const refinementNames =
                this.$searchContext.state.refinements[`categories.lvl${this.level}.text`] || []

            const refinementSlugs =
                this.$searchContext.state.refinements[`categories.lvl${this.level}.slug`] || []

            const refinements = refinementNames.map((refinement, index) => {
                const slug = refinementSlugs[index].value.split('|')

                const routeObj = {
                    name: 'category',
                    params: slug.reduce((acc, lvl, lvlIndex) => {
                        acc[`lvl${lvlIndex}`] = lvl
                        return acc
                    }, {}),
                    query: {},
                }

                return {
                    ...refinement,
                    slug,
                    route: this.linkBuilder(routeObj),
                }
            })

            const values = refinements.filter(
                (refinement) => refinement.slug.join('/').indexOf(this.catalogData.slug) === 0
            )

            const categoryGroup = {
                title: 'Category',
                values,
            }

            return categoryGroup
        },
    },
}
